import { US_COUNTRY } from 'kb-shared/utilities/countries';

export const LOCATION_OPTIONS = [
  {
    value: 'Vios_Fertility-Vancouver',
    label: 'Vios Fertility-Vancouver',
    state: 'WA'
  },
  {
    value: 'Vios_Fertility-Aurora',
    label: 'Vios Fertility-Aurora',
    state: 'IL'
  },
  {
    value: 'Vios_Fertility-Lindbergh',
    label: 'Vios Fertility-Lindbergh',
    state: 'MO'
  },
  {
    value: 'Vios_Fertility_Institute_Milwaukee',
    label: 'Vios Fertility Institute Milwaukee',
    state: 'WI'
  },
  {
    value: 'Vios_Fertility-Crest_Hill',
    label: 'Vios Fertility-Crest Hill',
    state: 'IL'
  },
  {
    value: 'Vios_Fertility-Glenview',
    label: 'Vios Fertility-Glenview',
    state: 'IL'
  },
  {
    value: 'Vios_Fertility-Geneva',
    label: 'Vios Fertility-Geneva',
    state: 'IL'
  },
  {
    value: 'Vios_Fertility-West_Loop',
    label: 'Vios Fertility-West Loop',
    state: 'IL'
  },
  {
    value: 'Vios_Fertility-Wicker_Park',
    label: 'Vios Fertility-Wicker Park',
    state: 'IL'
  },
  {
    value: 'Vios_Fertility-Hoffman_Estates',
    label: 'Vios Fertility-Hoffman Estates',
    state: 'IL'
  },
  {
    value: 'Vios_Fertility_Institute_St.Louis',
    label: 'Vios Fertility Institute St. Louis',
    state: 'MO'
  },
  {
    value: 'Vios_Fertility_Institute_Michigan',
    label: 'Vios Fertility Institute Michigan',
    state: 'MI'
  },
  {
    value: 'Centers_for_Reproductive_Medicine',
    label: 'Centers for Reproductive Medicine',
    state: 'CFRM'
  }
];

// stripe account ids are starting with pk_test_ for test mode
// for production mode, they will start with pk_live_
export const STRIPE_ACCOUNTS_BY_LOCATION = [
  {
    location: 'VFI Chicago',
    stripeAccountId:
      'pk_live_51MMvelJJfpnhWK2vfL3x3vj0Kbj7rx8zZYhgVor5O9lNzhc5N4O2wA27fgsYPfDv1TarYnbrZ74prx0OLogIPgsv005c68RoIz',
    stripeTestAccountId:
      'pk_test_51MMvelJJfpnhWK2vERcTQ6qtWmTOPToCztIjhcWuxoeXtifw2qGrTc5sSsSZxpxqE6UUXJnoBukKPYzXJinumFld00VIfMDKur',

    state: 'IL'
  },
  {
    location: 'VFI St Louis',
    stripeAccountId:
      'pk_live_51MN059ImMceXt5DnceYyF2MexBDlV2DfirbOnzzq1xWiwzxtftKrZd38oc7LHeWg0SFfSurxnpbYNDCucHGSEtAD00IkqtN4jM',
    stripeTestAccountId:
      'pk_test_51MN059ImMceXt5DnnevqcSBKCAoIKUyMDlZVyLwRnSKkHLc6gyLA6C81ijcuy94sqCMyts83qgqUpzZE31H5I0Uv00pXxQc0Z8',
    state: 'MO'
  },
  {
    location: 'VFI Milwaukee',
    stripeAccountId:
      'pk_live_51MN0DFCqXAfWHyEnFXTcROf7K4L8g3aWebvrwP7kKUj4UWFULWUSCyhVBjTyMsm0rnUVadXggcsT4Axz0ICfbETt00Eyv9tJrB',
    stripeTestAccountId:
      'pk_test_51MN0DFCqXAfWHyEnM7NeKvNQPCEizhotHkV0lpul3c6GoRfBgmLzmBH8eIGIWpBXHSbemHCnGhCF3YTJFg0bFobH00DwGKJvX0',
    state: 'WI'
  },
  {
    location: 'VFI Michigan',
    stripeAccountId:
      'pk_live_51MN0PjCNkW3pE1cejlPiwNM7U7mfOccMWdVIupZuqc6wfGTWE4eU7rJlnbNoTiQZhm6ju3qWNJsM698R9gjX1k6D00r9F8EfcU',
    stripeTestAccountId:
      'pk_test_51MN0PjCNkW3pE1ce1WOrx3QuKd3On3jDsbzYleXwlT9Z4Xtvi0EV5OWGfVXdiWXhlTPK1N6lJgeNZHAuurXBhfqD00b15X4s1S',
    state: 'MI'
  },
  {
    location: 'VFI Pacific Northwest',
    stripeAccountId:
      'pk_live_51MN0Z9Er7cFoFQ4s6gY2Z93oAdvcH8DtRYzewLrsXVv33XSRBkodWHVWtlcSvWRhe0HCbyxwFqIgpQgVBvPLK6ag00yTgrT7si',
    stripeTestAccountId:
      'pk_test_51MN0Z9Er7cFoFQ4sBTP1E87FPDk7apl4wLGy8HuckvSgellHQdg2y8vCgmSW1ySFQdVobNYBAHVHcAU0hMl8TdTp00oG01zvRF',
    state: 'WA'
  },
  {
    location: 'Centers for Reproductive Medicine',
    stripeAccountId:
      'pk_live_51MPaiwKTTG36lkky2x2oACu85Izo1yyoobKfzGWatsKaRbhEQAc3bDIrhAg1M6hIrD540KjV8fEs8dSoWmcDgjhj00r2dsprmw',
    stripeTestAccountId:
      'pk_test_51MN0Z9Er7cFoFQ4sBTP1E87FPDk7apl4wLGy8HuckvSgellHQdg2y8vCgmSW1ySFQdVobNYBAHVHcAU0hMl8TdTp00oG01zvRF',
    state: 'CFRM'
  }
];

export const DEFAULT_USER = { country: US_COUNTRY.value, isKindbodyRx: false };
